import { render, staticRenderFns } from "./New_Paiement.vue?vue&type=template&id=223417d7&"
import script from "./New_Paiement.vue?vue&type=script&lang=js&"
export * from "./New_Paiement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports